import Model from '@/models/Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Job extends Model {
  resource() {
    return 'jobs'
  }

  get image() {
    if (!this.gallery || !this.gallery.length) return
    return this.gallery[0].thumb_url || this.gallery[0].permanent_url
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
